
import { Options, Vue } from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import { Line } from '@/api/models/Line';
import { dataModule } from '@/store/data';
import { imageLoader } from '@/store/image-loader';
import NButton from '@/uikit/buttons/NButton.vue';
import NDraw from '@/uikit/draw/NDraw.vue';
import NLoadingCircle from '@/uikit/loading/NLoadingCircle.vue';
import ImageLoadError from '@/components/common/ImageLoadError.vue';

@Options({
  name: 'LinesROI',
  components: { ImageLoadError, NButton, NDraw, NLoadingCircle }
})
export default class LinesROI extends Vue {
  @Prop({ type: Object, required: true })
  readonly model!: Line;

  @Prop({ type: Boolean, default: false })
  readonly hasFullscreen!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  loading = false;
  loaded = false;
  error = false;

  imageUrl = '';
  imageDataUrl = '';
  name = '';

  @Watch('model')
  async load() {
    if (this.model.camera) {
      const camera = await dataModule.camerasModule.getById(this.model.camera);
      if (camera) {
        this.imageUrl = camera.screenshot;
        this.name = camera.name;
      }
    }

    if (this.model.video_archive) {
      const video_archive = await dataModule.videosModule.getById(this.model.video_archive);
      if (video_archive) {
        this.imageUrl = video_archive.screenshot;
        this.name = video_archive.name || '';
      }
    }
  }

  get points() {
    return this.model.points || [];
  }

  set points(points: number[][]) {
    this.model.points = points;
  }

  async created() {
    await this.load();
    await this.loadCameraImage();
  }

  async loadCameraImage(resetCache = false) {
    try {
      this.error = false;
      this.loading = true;
      const image = await imageLoader.get(this.imageUrl, resetCache);
      this.imageDataUrl = image;
      this.loaded = true;
    } catch (e) {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  clearRect() {
    this.$refs.drawTool?.clear();
  }

  dispatchShowModal() {
    this.$emit('showModal');
  }
}
